import React from "react";
import PdfBase from "./PdfBase";
import { generateMovementPdf } from "./generator";
import ExcelBase from "../Excel/ExcelBase";

const PdfGenerator = ({
  schedule,
  company,
  openingBalance,
  movementBalance,
  closingBalance,
  movementLines,
  notes,
  reviewNotes,
}) => {
  const sharedArgs = [
    schedule,
    company,
    openingBalance,
    movementBalance,
    closingBalance,
    movementLines,
    notes,
    reviewNotes,
  ];
  return (
    <>
      <PdfBase
        company={company}
        enableDraftView
        generatePdf={(forView) => generateMovementPdf(forView, ...sharedArgs)}
        downloadName='Provision Movement Schedule'
      />
      <ExcelBase
        generateExcel={(forView) =>
          generateMovementPdf(forView, ...sharedArgs, true)
        }
      />
    </>
  );
};

export default PdfGenerator;
